export default [
  {
    header: 'sidebar.administration',
    permission: ['admin', 'chief_manager'],
    // action: 'read',
    // resource: 'auth/user',
  },
  {
    title: 'others.users',
    icon: 'UsersIcon',
    route: 'users',
    permission: ['admin'],
    // action: 'read',
    // resource: 'auth/user',
  },
  {
    title: 'others.references',
    icon: 'SettingsIcon',
    route: 'reference',
    permission: ['admin'],
    // action: 'read',
    // resource: 'auth/user',
  },
]
